<template lang="pug">
v-expansion-panel.v-expansion-panel--outlined
  v-expansion-panel-header.text-body-2
    v-list-item().pa-0
      v-list-item-action.mr-2(
        v-if="signIcon"
      )
        tooltip-wrap(
          :text="signIcon.text"
        )
          v-btn(fab text small :color="signIcon.color"): v-icon() {{signIcon.icon}}
      v-list-item-content
        v-list-item-title Соглашения
        v-list-item-subtitle(v-if="needToSign")
          v-chip(color="warning" outlined small)
            v-icon(left small) mdi-alert
            | требуется подпись
  v-expansion-panel-content(:style="`max-height: 280px`").overflow-auto.scroll
    v-list-item(v-if="signsLength")
      v-list-item-action.mr-4
        tooltip-wrap(text="Скачать")
          v-btn(
            fab outlined color="primary lighten-2"
            @click="getPrintVersion"
          ): v-icon(large) mdi-file-download
      v-list-item-content
        v-list-item-title.text-body-1: strong {{ contract.number }}
        v-list-item-subtitle(v-if="!loading")
          tooltip-wrap(text="Скачать подпись")
            v-chip.mr-2(
              v-for="sign in Object.values(signs)"
              v-if="sign.id"
              :key="sign.id"
              color="primary"
              small
              @click="getSignature(sign.id)"
            )
              v-icon(left small) mdi-download
              | {{ sign.text }}

    file-sign.mt-4(
      v-if="needToSign"
      :files="contractDocument"
      :successCallback="signDocument"
    )
</template>
<script>
import { getFileFromUrl } from '@/utils/base64';
import FileSign from '@/components/FileSignature/index.vue';

const SIGNS = {
  oneSign: 1,
  allSign: 2,
};
const SIGN_ICONS = {
  [SIGNS.oneSign]: { icon: 'mdi-check', color: 'success lighten-1', text: 'подписан одной из сторон' },
  [SIGNS.allSign]: { icon: 'mdi-check-all', color: 'success', text: 'подписан обеими сторонами' },
};

export default {
  components: { FileSign },
  props: {
    contract: { type: Object, required: true },
    isEnrollment: { type: Boolean, required: true },
  },
  data() {
    return {
      loading: false,
      signs: {
        customer: {
          text: 'подписан заказчиком',
        },
        executor: {
          text: 'подписан исполнителем',
        },
      },
    };
  },
  computed: {
    signsLength() {
      return Object.values(this.signs).filter(({ id }) => id).length;
    },
    signIcon() {
      return SIGN_ICONS[this.signsLength];
    },
    needToSign() {
      const { is_signed_customer: customer, is_signed_executor: executor } = this.contract;
      const checkedValue = this.isEnrollment
        ? customer : !customer || (customer && !executor);
      return !checkedValue;
    },
    contractDocument() {
      const { url, original_name: originalName } = this.contract?.document;
      return [{ url, originalName }];
    },
  },
  created() {
    const { is_signed_customer: customer, is_signed_executor: executor } = this.contract;
    if (customer || executor) {
      this.loading = true;
      this.getSignDocuments();
    }
  },
  methods: {
    async getPrintVersion() {
      await this.$api.contracts.getPrintVersion(this.contract.id).then((data) => {
        const blob = new Blob([data.data], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl);
      });
    },
    async getSignatureFile(signature, filename = 'signature.sig') {
      const link = document.createElement('a');
      const file = await getFileFromUrl(`data:application/octet-stream;base64,${signature}`, filename);
      link.href = URL.createObjectURL(file);
      link.download = `${filename}`;
      link.click();
    },
    async getSignDocuments() {
      const { data } = await this.$api.contracts.getSignDocuments(this.contract.id);
      data.data.forEach((sign) => {
        if (sign.owner_id === this.contract.owner_id) {
          this.signs.customer = { ...this.signs.customer, ...sign };
        } else this.signs.executor = { ...this.signs.executor, ...sign };
      });
      this.loading = false;
    },
    async getSignature(id) {
      const { data } = await this.$api.contracts.getSignature(this.contract.id, id);
      console.log(data);
      this.getSignatureFile(data);
    },
    async signDocument([value]) {
      await value.validate();
      const {
        hash,
        signature,
        signData: {
          commonName, serialNumber, validFromDate, validToDate, issuerName, title,
        },
      } = value;
      const payload = {
        hash,
        position: title,
        sign_hash: signature,
        common_name: commonName,
        issuer_name: issuerName,
        serial_number: serialNumber,
        valid_from_at: validFromDate,
        valid_to_at: validToDate,
      };
      const newContract = { ...this.item };
      await this.$rHandler(
        this.$api.contracts.signDocument(this.contract.id, payload),
        () => {
          const key = this.isEnrollment ? 'is_signed_customer' : 'is_signed_executor';
          newContract[key] = true;
        },
      );
      this.$emit('set', newContract);
      this.getSignDocuments();
    },
  },
};
</script>
